<form novalidate (ngSubmit)="save()" #formClientInfo="ngForm">
    <div class="card-body mt-0 pt-4">
        <div class="row">
            <div class="col-lg-4 separator-vertical mb-5">
                <div class="form-group">
                    <h6>Food</h6>
                </div>
                <div class="form-group">
                    <label>Food Type:</label>
                    <select class="form-control " name="_food_type"
                        [(ngModel)]="petService.pet_metabolic.tag7">
                        <option value=""></option>
                        <option [value]="item.item_desc" *ngFor="let item of catalogService.food_type">
                            {{ item.item_desc }}
                        </option>
                    </select>
                </div>
                <div class="row">
                    <div class="col-lg-6 form-group">
                        <label class="form-label">Quantity:</label>
                        <input type="text" class="form-control " name="_food_cnt" autocomplete="off"
                            [(ngModel)]="petService.pet_metabolic.tag9" />
                    </div>
                    <div class="col-lg-6 form-group">
                        <label class="form-label">&nbsp;</label>
                        <select class="form-control  " name="_food_cnt_bis"
                            [(ngModel)]="petService.pet_metabolic.tag9bis">
                            <option value=""></option>
                            <option [value]="item.description" *ngFor="let item of FOOD_CNT">
                                {{ item.description }}
                            </option>
                        </select>
                    </div>
                </div>
                <div class="form-group">
                    <label>Frequency:</label>
                    <select class="form-control " name="_food_freq"
                        [(ngModel)]="petService.pet_metabolic.tag10">
                        <option value=""></option>
                        <option value="BID">BID</option>
                        <option value="MO">MO</option>
                        <option value="SID">SID</option>
                        <option value="TID">TID</option>
                       
                    </select>
                </div>
                <div class="row">
                    <div class="form-group col-lg-6">
                        <label>Act:</label>
                        <select class="form-control " name="_food_act"
                            [(ngModel)]="petService.pet_metabolic.tag8">
                            <option value=""></option>
                            <option [value]="item.description" *ngFor="let item of FOOD_ACT">
                                {{ item.description }}
                            </option>
                        </select>
                    </div>
                    <div class="form-group col-lg-6">
                        <label>Abnormal:</label>
                        <select class="form-control " name="_food_abn"
                            [(ngModel)]="petService.pet_metabolic.tag11">
                            <option value=""></option>
                            <option [value]="item.description" *ngFor="let item of FOOD_ABNORMAL">
                                {{ item.description }}
                            </option>
                        </select>
                    </div>
                </div>
            </div>
            <div class="col-lg-4 separator-vertical mb-5">
                <div class="form-group">
                    <h6>Urine</h6>
                </div>
                <div class="form-group">
                    <label>Type:</label>
                    <select class="form-control " name="_urine"
                        [(ngModel)]="petService.pet_metabolic.tag21">
                        <option value=""></option>
                        <option [value]="item.description" *ngFor="let item of URINE">
                            {{ item.description }}
                        </option>
                    </select>
                </div>
                <div class="form-group">
                    <label>Vol:</label>
                    <select class="form-control " name="_urine_vol"
                        [(ngModel)]="petService.pet_metabolic.tag22">
                        <option value=""></option>
                        <option [value]="item.description" *ngFor="let item of URINE_VOL">
                            {{ item.description }}
                        </option>
                    </select>
                </div>
                <div class="form-group">
                    <label>Frequency:</label>
                    <select class="form-control " name="_urine_freq"
                        [(ngModel)]="petService.pet_metabolic.tag23">
                        <option value=""></option>
                        <option [value]="item.description" *ngFor="let item of URINE_FREQ">
                            {{ item.description }}
                        </option>
                    </select>
                </div>
                <div class="row">
                    <div class="form-group col-lg-6">
                        <label>Color:</label>
                        <select class="form-control " name="_urine_color"
                            [(ngModel)]="petService.pet_metabolic.tag24">
                            <option value=""></option>
                            <option [value]="item.description" *ngFor="let item of URINE_COLOR">
                                {{ item.description }}
                            </option>
                        </select>
                    </div>
                    <div class="form-group col-lg-6">
                        <label>Abnormal:</label>
                        <select class="form-control " name="_urine_abn"
                            [(ngModel)]="petService.pet_metabolic.tag25">
                            <option value=""></option>
                            <option [value]="item.description" *ngFor="let item of URINE_ABNORMAL">
                                {{ item.description }}
                            </option>
                        </select>
                    </div>
                </div>
            </div>
            <div class="col-lg-4 mb-5">
                <div class="form-group">
                    <h6>Fecal</h6>
                </div>
                <div class="form-group">
                    <label>Type:</label>
                    <select class="form-control " name="_fecal_type"
                        [(ngModel)]="petService.pet_metabolic.tag18">
                        <option value=""></option>
                        <option [value]="item.description" *ngFor="let item of FECAL">
                            {{ item.description }}
                        </option>
                    </select>
                </div>
                <div class="form-group">
                    <label>Vol:</label>
                    <select class="form-control " name="_fecal_vol"
                        [(ngModel)]="petService.pet_metabolic.tag16">
                        <option value=""></option>
                        <option [value]="item.description" *ngFor="let item of FECAL_VOL">
                            {{ item.description }}
                        </option>
                    </select>
                </div>

                <div class="form-group">
                    <label>Frequency:</label>
                    <select class="form-control " name="_fecal_freq"
                        [(ngModel)]="petService.pet_metabolic.tag17">
                        <option value=""></option>
                        <option [value]="item.description" *ngFor="let item of FECAL_FREQ">
                            {{ item.description }}
                        </option>
                    </select>
                </div>
                <div class="row">
                    <div class="form-group col-lg-6">
                        <label>Color:</label>
                        <select class="form-control " name="_fecal_color"
                            [(ngModel)]="petService.pet_metabolic.tag19">
                            <option value=""></option>
                            <option [value]="item.description" *ngFor="let item of FECAL_COLOR">
                                {{ item.description }}
                            </option>
                        </select>
                    </div>
                    <div class="form-group col-lg-6">
                        <label>Abnormal:</label>
                        <select class="form-control " name="_fecal_abn"
                            [(ngModel)]="petService.pet_metabolic.tag20">
                            <option value=""></option>
                            <option [value]="item.description" *ngFor="let item of FECAL_ABNORMAL">
                                {{ item.description }}
                            </option>
                        </select>
                    </div>
                </div>

            </div>
        </div>
        <div class="row">
            <div class="col-lg-12 separator separator-dashed mt-0 mb-3"></div>
            <div class="col-lg-12">
                <h6>Water</h6>
            </div>
            <div class="col-lg-4 form-group">
                <label>Type:</label>
                <select class="form-control " name="_water"
                    [(ngModel)]="petService.pet_metabolic.tag14">
                    <option value=""></option>
                    <option [value]="item.description" *ngFor="let item of WATER">
                        {{ item.description }}
                    </option>
                </select>
            </div>
            <div class="col-lg-4 form-group">
                <label>Frequency:</label>
                <select class="form-control " name="_water_freq"
                    [(ngModel)]="petService.pet_metabolic.tag13">
                    <option value=""></option>
                    <option [value]="item.description" *ngFor="let item of WATER_FREQ">
                        {{ item.description }}
                    </option>
                </select>
            </div>
            <div class="col-lg-4 form-group">
                <label>Act:</label>
                <select class="form-control " name="_water_act"
                    [(ngModel)]="petService.pet_metabolic.tag12">
                    <option value=""></option>
                    <option [value]="item.description" *ngFor="let item of WATER_ACT">
                        {{ item.description }}
                    </option>
                </select>
            </div>

        </div>
    </div>
    <div class="card-footer text-right py-4">

        <button type="submit" class="btn btn-primary" [disabled]="formClientInfo.invalid">
            Save Changes
        </button>
    </div>
</form>